export default {
  generateFromHtml(html) {
    return this.post('/pdf/generate-from-html', html)
      .then((responseData) => responseData);
  },
};
